module.exports = __webpack_public_path__ + "img/Porte hybride alu pvc PROFERM.0a6ed9d4.jpg";